import React, { useMemo } from 'react';
import SearchFiltersRefinementList from './generic/SearchFiltersRefinementList';
import { useCurrentRefinements } from 'react-instantsearch-hooks-web';
import { useSearchStateLocation } from '../hooks/useSearchStateLocation';
import config from '../config/config';

const SearchFiltersGroupMore = () => {
	const { submarket } = useSearchStateLocation();
	const { items, canRefine, refine } = useCurrentRefinements();
	const hasRefinement = useMemo( () => {
		const attributes = items.map( ( item ) => item.attribute );
		const hasTour = attributes.includes( config.FILTER_ATTRIBUTES.tourOption );
		const hasNeighborhood = attributes.includes( config.FILTER_ATTRIBUTES.neighborhoodType );
		const hasAmenity = attributes.includes( config.FILTER_ATTRIBUTES.amenity );
		const hasSchool = attributes.includes( config.FILTER_ATTRIBUTES.schoolDistrict );
		return hasTour || hasNeighborhood || hasAmenity || hasSchool;
	}, [ items ] );

	return (
		<div className='tw-space-y-6'>
			<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.designerCollections} label="Designer Collections" />
			<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.tourOption} label="Tour Options" />
			<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.neighborhoodType} label="Neighborhood Type" />
			<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.amenity} label="Amenities" />
			{submarket && (
				<SearchFiltersRefinementList attribute={config.FILTER_ATTRIBUTES.schoolDistrict} label="School District" />
			)}
		</div>
	);
};

export default SearchFiltersGroupMore;
